import { Fragment, useContext, useEffect, useState } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import { getPaymentMethodStructure, getPaymentMethodsTypes } from '../../helpers/paymentMethods';
import { SVG_paymentMethod } from '../elements/SVG';
import { BlockSummaryPaymentExtraData } from './BlockSummaryPaymentExtraData';

export const BlockSummaryPaymentNew = ({ changeScreen, types = false }) => {

    const { mainReducer } = useContext( MainContext );
    const [paymentMethodsTypes, setPaymentMethodsTypes] = useState([]);

    useEffect( () => {
        async function getPaymentMethods() {
            const periodicity = mainReducer.state.selectedLicense.periodicity;
            const paymentMethodsTypes = await getPaymentMethodsTypes(periodicity, mainReducer.state.EU);
            setPaymentMethodsTypes( (types === false) ? paymentMethodsTypes : paymentMethodsTypes.filter(type => types.includes(type)) );
        }

        getPaymentMethods();

        if (mainReducer.state.newPaymentMethod === false) {
            const onlyType = ((types !== false) && (types.length == 1)) ? types[0] : false;
            const action = {
                type: 'changeNewPaymentMethod',
                payload: {
                    type: onlyType,
                    data: (onlyType === false) ? false : getPaymentMethodStructure( onlyType )
                }
            };
            mainReducer.dispatch(action);
        }       
    }, []);

    const handleOnChangePaymentType = ( type ) => {
        const action = {
            type: 'changeNewPaymentMethod',
            payload: {
                type: type,
                data: getPaymentMethodStructure( type )
            }
        };
        mainReducer.dispatch(action);
    }

    const changeScreenLocal = () => {
        const action = {
            type: 'changeNewPaymentMethod',
            payload: false
        };
        mainReducer.dispatch(action);
        if ((mainReducer.state.paymentMethods.length == 1) && (mainReducer.state.paymentMethods[0].id == mainReducer.state.currentPaymentMethod.id)) {
            changeScreen('collapsed');
        } else {
            changeScreen('saved');
        }
    }
    return  <div className="e__plns__opt__pay__wpr">
                    {paymentMethodsTypes.map( type =>
                        <Fragment key={type}>
                        <div className="e__plns__opt__pay__wpr__item">
                            <div className="e__chck" title={ getText('payment_method_title_' + type) }>
                                <input onChange={ () => handleOnChangePaymentType(type) } type="radio" id={`newPaymentMethod_${type}`} checked={ (mainReducer.state.newPaymentMethod !== false) && (mainReducer.state.newPaymentMethod.type == type) } />
                                <label htmlFor={`newPaymentMethod_${type}`}>
                                    <span className="e__chck__ico">
                                        <SVG_paymentMethod type={ type } />
                                    </span>
                                    <span className="e__chck__hd">{ getText('payment_method_title_' + type) }</span>
                                </label>
                            </div>
                            {((mainReducer.state.newPaymentMethod !== false) && (mainReducer.state.newPaymentMethod.type == type)) &&
                                <BlockSummaryPaymentExtraData type={ type } getPaymentMethodStructure={ getPaymentMethodStructure } />
                            }
                        </div>    
                        </Fragment>
                    )}           
                {((mainReducer.state.paymentMethods !== false) && (mainReducer.state.paymentMethods.length > 0)) &&
                    <button className="e__lnk" onClick={ changeScreenLocal }>{ getText('volver_nuevo_metodo_de_pago') }</button>
                }
            </div>;
}